// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vdp-datepicker {\n  display: inline-block;\n}\n.vdp-datepicker .form-control {\n  background-color: #fff;\n}", ""]);
// Exports
module.exports = exports;
